<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="aircraftRelationAudits && aircraftRelationAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="aircraftRelationAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Aircraft Relation audits </ng-template>

  <mat-accordion>
    <mat-expansion-panel
      *ngIf="aircraftRelation.phoneNumberId"
      (opened)="phoneNumberOpened(aircraftRelation.phoneNumberId)"
    >
      <mat-expansion-panel-header> Phone Number </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <sd-portal-phone-number-audit-list
          #phoneNumberAuditList
          [phoneNumberId]="aircraftRelation.phoneNumberId"
          [loading]="phoneNumberAuditsLoading"
          [phoneNumberAudits]="phoneNumberAudits"
          (nextPage)="nextPhoneNumberPage.emit($event)"
          (loadPhoneNumber)="loadPhoneNumber.emit($event)"
        ></sd-portal-phone-number-audit-list>
      </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel
      *ngIf="aircraftRelation.faxNumberId"
      (opened)="faxNumberOpened(aircraftRelation.faxNumberId)"
    >
      <mat-expansion-panel-header> Fax Number </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <sd-portal-phone-number-audit-list
          #faxNumberAuditList
          [phoneNumberId]="aircraftRelation.faxNumberId"
          [loading]="faxNumberAuditsLoading"
          [phoneNumberAudits]="faxNumberAudits"
          (nextPage)="nextFaxNumberPage.emit($event)"
          (loadPhoneNumber)="loadFaxNumber.emit($event)"
        ></sd-portal-phone-number-audit-list>
      </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel
      *ngIf="aircraftRelation.emailAddressId"
      (opened)="emailAddressOpened(aircraftRelation.emailAddressId)"
    >
      <mat-expansion-panel-header> Email Address </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <sd-portal-email-address-audit-list
          #emailAddressAuditList
          [emailAddressId]="aircraftRelation.emailAddressId"
          [loading]="emailAddressAuditsLoading"
          [emailAddressAudits]="emailAddressAudits"
          (nextPage)="nextEmailAddressPage.emit($event)"
          (loadEmailAddress)="loadEmailAddress.emit($event)"
        >
        </sd-portal-email-address-audit-list>
      </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel
      *ngIf="aircraftRelation.addressId"
      (opened)="addressOpened(aircraftRelation.addressId)"
    >
      <mat-expansion-panel-header> Address </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <sd-portal-address-audit-list
          #addressAuditList
          [addressId]="aircraftRelation.addressId"
          [loading]="addressAuditsLoading"
          [addressAudits]="addressAudits"
          (nextPage)="nextAddressPage.emit($event)"
          (loadAddress)="loadAddress.emit($event)"
        ></sd-portal-address-audit-list>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
</ng-template>
